module.exports = __webpack_public_path__ + "img/logo-horizontal-removebg-preview.70035d02.png";